import React from 'react';
import bigtappLogoWhite from '../assets/bigtapplogowhite.png';
import beeonixLogo from '../assets/beeonixlogo.png';

// Appbar logo placement per spec §3 / §10: Bigtapp (white mark, reads on the
// navy shell) sits left, Beeonix sits right before the avatar. Both 40px high.
const Logo = ({ position = 'both', className = '' }) => {
  const justification = (position === 'left' || position === 'right') ? 'justify-center' : 'justify-between';

  return (
    <div className={`flex items-center ${justification} ${className}`}>
      {(position === 'left' || position === 'both') && (
        <img
          src={bigtappLogoWhite}
          alt="Bigtapp Logo"
          className="h-10 w-auto object-contain"
        />
      )}

      {position === 'both' && <div className="mx-4"></div>}

      {(position === 'right' || position === 'both') && (
        <img
          src={beeonixLogo}
          alt="Beeonix Logo"
          className="h-10 w-auto object-contain"
        />
      )}
    </div>
  );
};

export default Logo;